if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.remove('hidden');

        const hiddenInputs = this.form.querySelectorAll('input[type="hidden"]');
        let productForm = {};
        hiddenInputs.forEach(function(input) {
          productForm[input.name] = input.value;
        });

        let formData = {
          'items': []
        };


        const productIdArray = typeof productForm['id'] === 'string' ? productForm['id'].split(',') : [];

        if (productIdArray.length > 1) {
          // If the string has a comma, create a new object for each value
          productIdArray.forEach(productId => {
            formData.items.push({
              id: productId.trim(),
              'product-id': productForm['product-id'].trim(),
              'quantity': 1
            });
          });
        } else {
          // If the string doesn't have a comma, add the original object
          const productInfoElement = document.querySelector('product-info > h1');
          const bundleProductName = productInfoElement ? productInfoElement.textContent.trim() : 'Unknown Product';
          if( bundleProductName === 'Newton Gift Card' && document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]:checked')) {
            formData.items.push({
              id: productForm['id'] ? productForm['id'].trim() : '',
              quantity: 1,
              properties: {
                __shopify_send_gift_card_to_recipient: 'on',
                'Recipient email': document.querySelector('input[name="properties[Recipient email]"]').value,
                'Recipient name': document.querySelector('input[name="properties[Recipient name]"]').value,
                'Message': document.querySelector('textarea[name="properties[Message]"]').value,
                'Send on': document.querySelector('input[name="properties[Send on]"]').value,
                '__shopify_offset': document.querySelector('input[name="properties[__shopify_offset]"]').value,
                '_gift_card': `added from ${bundleProductName} page`
              }
            });
          } else {
            if (productForm['id'] || productForm['product-id']) {
              formData.items.push({
              id: productForm['id'] ? productForm['id'].trim() : productForm['product-id'],
              quantity: 1,
              properties: {
                '_added_from_page': productForm['_added_from_page'] ? productForm['_added_from_page'] : `added from ${bundleProductName} page`
              }
              });
            } else {
              console.error('Error: Missing product ID or product-id in productForm.');
              return false;
            }
          }
        }

        if (this.cart) {
          let sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections = sectionIds.join(',');
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        if ( document.querySelector('input[name="bundle"]:checked') && document.querySelector('input[name="bundle"]:checked').id !== 'no-bundle' ) {
          const selectedProductStyle = document.querySelector('input[name="bundle-option"]:checked');
          const selectedProductStyleId = selectedProductStyle.nextElementSibling.value;
          const bundleProductName = document.querySelector('product-info > h1').textContent.trim();
          formData.items.push({
            id: selectedProductStyleId,
            quantity: 1,
            properties: {
              '_added_from_page': `added from ${bundleProductName} page`
            }
          });
        }

        if ( document.querySelector('input[name="bundle-product-single"]:checked') ) {
          const bundleProductIds = document.querySelectorAll('input[name="bundle-product-single"]:checked');
          bundleProductIds.forEach(bundleProduct => {
          const bundleProductId = bundleProduct.value;
          const bundleProductName = document.querySelector('product-info > h1').textContent.trim();
          formData.items.push({
            id: bundleProductId,
            quantity: 1,
            properties: {
              '_added_from_page': `added from ${bundleProductName} page`
            }
          });
          });
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData?.items[0]?.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.id,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            if (window.newrelic) {
              newrelic.noticeError(e, {
                action: 'AddToCart',
                type: 'error',
                message: e.message,
                productId: formData?.items[0]?.id || 'unknown'
              });
            }
            console.error('Cart Error:', e); // Optional: Log to console
          })
          .finally(() => {
            this.submitButton.classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        if ( !errorMessage?.email ) {
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        }

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
